import React from 'react';
import helper from 'components/utils/helper';
import ConfigContext from 'context/ConfigContext';
import { Container, Row, Col } from 'themes/MoGrid';
import { Helmet}  from "react-helmet";
import { StoriesContainer, Breadcrumb, Featured, HeroContainer, HeroImage, HeroText, FeaturedHeading, FeaturedTitle, Story, Media, Image, Play, Info, Tags, Title, Date, LoadMore } from './Stories.style';

const Stories = ({ cms, articles }) => {
    let configContext = React.useContext(ConfigContext);
    let config = configContext.config;
    const noInitStories = 8, noMoreStories = 6;
    const [stories, setStories] = React.useState([]);
    const [tagStories, setTagStories] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [tag, setTag] = React.useState();

    React.useEffect(() => {
        // Set current story tag
        const setCurrentTag = () => {
            let urlTag = helper.getUrlParam('tag');
            if(urlTag) {
                if(cms.nav && cms.nav.siteNav && cms.nav.siteNav.stories){
                    let tagList = [...cms.nav.siteNav.stories.primary, ...cms.nav.siteNav.stories.secondary];
                    for(let item of tagList){
                        if(item.id === urlTag){
                            setTag(item);
                            break;
                        }
                    }
                }
            }
        }
        setCurrentTag();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);
    React.useEffect(() => {
        const getStories = () => {
            let result = [];
            result = articles.map(article => {
                let id = article.components[0];
                let item = cms.components[id];
                item.id = id;
                item.url = article.url;
                item.title = article.title;
                item.hasVideo = storyHasVideo(item.gallery);
                return item;
            });
            result = sortStories(result);
            if(tag){
            result = result.filter(story => story.tags.findIndex(ele => ele.id === tag.id) >= 0);
            }
            setTagStories(result); // Number of stories with tag.
            return result.slice(0, noInitStories + (page*noMoreStories));
        }
        const sortStories = stories => {
            let result = stories;
            result.sort(function(a,b){
                if (a.publishedDate && b.publishedDate) {
                    return new window.Date(b.publishedDate) - new window.Date(a.publishedDate);
                }
                return 0;
            });
            return result;
        }
        const storyHasVideo = gallery => {
            let result = false;
            for(let item of gallery){
                if(item.type === 'video'){
                    result = true;
                    break;
                }
            }
            return result;
        }
        setStories(getStories());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[page, tag]);

    return (
        <Container>
            {/* React Helmet to manage meta tags in document head */}
            <Helmet>
                <meta property="og:url" content={window.location.href} />
                <meta property="og:title" content="Movember Stories Listing"/>
            </Helmet>
              <StoriesContainer>
                    <Breadcrumb>
                        {cms.pages && cms.pages.stories && <a href={cms.pages.stories.url}>{cms.pages.stories.title}</a>}
                        {tag &&
                            <React.Fragment>
                                <i className="fas fa-chevron-right"/>
                                <a href={tag.url} >{tag.title}</a>
                            </React.Fragment>
                        }
                    </Breadcrumb>
                    { false && stories && stories[0] && stories[0].gallery && stories[0].gallery[0] && 
                        <Featured>
                            <HeroContainer>
                                <HeroImage href={stories[0].url + (tag ? `?tag=${tag.id}` : '')}>
                                    {helper.renderImage(stories[0].gallery[0])}
                                </HeroImage>
                                <HeroText href={stories[0].url}>
                                    <FeaturedHeading>Featured</FeaturedHeading>
                                    <FeaturedTitle>{stories[0].title}</FeaturedTitle>
                                </HeroText>
                            </HeroContainer>
                        </Featured>
                    }
                    <Row>
                        {stories.map((story, index) => (
                            <Col sm={index === 3 ? 6 : 4} xs={12} key={index} {...index === 4 ? {className: 'fifth-item'} : null}>
                                <Story isFifthItem={index === 4}>
                                    <Media>
                                        <Image href={story.url + (tag ? `?tag=${tag.id}` : '')}>
                                            {story.squareImage && helper.renderImage(story.squareImage, 'small')}
                                        </Image>
                                        { story.hasVideo && 
                                            <Play className="play" href={`${story.url}?autoplay=1`}><i className="fas fa-play" /></Play>
                                        }
                                    </Media>
                                    <Info>
                                        <Tags>
                                            {story.tags.map((tag, i) =>
                                                <React.Fragment key={i}>
                                                    {i > 0 && <span>|</span> }
                                                    <a href={tag.url}>{tag.title}</a>
                                                </React.Fragment>
                                            )}
                                        </Tags>
                                        <Title href={story.url + (tag ? `?tag=${tag.id}` : '')}><span className="title">{story.title}</span></Title>
                                        <Date>
                                            {story.publishedDate ? new window.Date(story.publishedDate).toLocaleDateString(['us', 'ca'].indexOf(config.getCountry()) >= 0 ? 'en-US' : undefined, { year: 'numeric', month: 'long', day: 'numeric' }) : ''}
                                        </Date>
                                    </Info>
                                </Story>
                            </Col>
                        ))}
                </Row>
                <LoadMore>
                    {(noInitStories + (page * noMoreStories) < tagStories.length) ?
                     <button onClick={() => setPage(page+1)}>Load More</button>
                     : (page > 0) ? <button onClick={() => window.scrollTo(0,0)}>Go To Top</button> : null
                    }
                </LoadMore>
            </StoriesContainer>
        </Container>
    );
}
 
export default Stories;